import { SubFormType } from '@ikegps/core-api';
import { BaseForm, FormModel, FormModelField, FormModelFieldNestedList, type ISpan, PLAForm } from '..';
import { CollectionModelFieldSubFormInstance } from '../collection';
import { FormModelFieldSubForm, FormModelFieldSelectList } from '../form';
import { SpanSubForm } from './SpanSubForm';

/**
 * Interface for accessing standard Pole fields on a FormModel.
 *
 * NOTE: If adding new fields to this interface, remember to also update PoleFormMapper in core-server.
 *
 * Fields which return a nullable result are not defined on all PoleForms.
 * For example, Sequence is not defined on IPF Forms.
 */
export interface IPoleForm extends ISpanForm {
	form: FormModel;

	statusField: FormModelFieldNestedList | null;
	sequenceField: FormModelField | null;
	idField: FormModelField;
	tagPhotosField: FormModelField;
	typeField: FormModelFieldNestedList | null;
	ownerField: FormModelFieldNestedList | null;
	circumferenceField: FormModelField | null;
	tipField: FormModelField;
	lowPowerAttachmentField: FormModelField | null;
	locationField: FormModelField;
	streetAddressField: FormModelField | null;
	noteField: FormModelField | null;
	ikePhotoField: FormModelField;
	lowPowerToCommField: FormModelField | null;
	equipmentField: FormModelFieldSubForm;
	anchorField: FormModelFieldSubForm;
}

export interface ISpanForm {
	spanField: FormModelFieldSubForm;
	spanTypeField: FormModelFieldSelectList;
	spanVectorField: FormModelField;
	spanMidSpanIkePhoto?: FormModelField;
	spanAttachmentHeightFields: FormModelField[];

	spanValue(instance: CollectionModelFieldSubFormInstance): ISpan;
	spanTypeMapping: Record<string, string>;
}

/**
 * Returns an IPoleForm for the given form if it is a Base Form or PLA Form, or null if it is neither.
 */
export function readPoleForm(form: FormModel): IPoleForm | null {
	if (BaseForm.isBaseForm(form)) {
		return new BaseForm(form);
	}
	if (PLAForm.isPLAForm(form)) {
		return new PLAForm(form);
	}
	return null;
}

export function readSpanForm(form: FormModel): ISpanForm | null {
	if (BaseForm.isBaseForm(form)) {
		return new BaseForm(form);
	}
	if (PLAForm.isPLAForm(form)) {
		return new PLAForm(form);
	}

	const spanSubForm = form.getTypedSubForm(SubFormType.SPAN);
	if (spanSubForm) {
		return new SpanSubForm(spanSubForm);
	}

	return null;
}
